// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/sharing/v2/sharing.v2.proto (package no.jotta.openapi.sharing.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { PublicShareRef } from "../../ref_pb.js";
import { PathItem } from "../../file/file.v2_pb.js";
import { Avatar } from "../../avatar_pb.js";
/**
 * @generated from enum no.jotta.openapi.sharing.v2.ShareMode
 */
export var ShareMode;
(function (ShareMode) {
    /**
     * NOT_SET defaults to VIEW mode to remain backwards compatible with old clients that did not send any ShareMode.
     *
     * @generated from enum value: NOT_SET = 0;
     */
    ShareMode[ShareMode["NOT_SET"] = 0] = "NOT_SET";
    /**
     * Users can only view the content on the link.
     *
     * @generated from enum value: VIEW = 1;
     */
    ShareMode[ShareMode["VIEW"] = 1] = "VIEW";
    /**
     * Users can view the content on the link, upload, and edit any existing content.
     *
     * @generated from enum value: EDIT = 2;
     */
    ShareMode[ShareMode["EDIT"] = 2] = "EDIT";
    /**
     * Users can view the content on the link and add new content, but not edit/change/modify.
     *
     * @generated from enum value: UPLOAD_ONLY = 3;
     */
    ShareMode[ShareMode["UPLOAD_ONLY"] = 3] = "UPLOAD_ONLY";
})(ShareMode || (ShareMode = {}));
// Retrieve enum metadata with: proto3.getEnumType(ShareMode)
proto3.util.setEnumType(ShareMode, "no.jotta.openapi.sharing.v2.ShareMode", [
    { no: 0, name: "NOT_SET" },
    { no: 1, name: "VIEW" },
    { no: 2, name: "EDIT" },
    { no: 3, name: "UPLOAD_ONLY" },
]);
/**
 * @generated from enum no.jotta.openapi.sharing.v2.FolderShareInviteStatus
 */
export var FolderShareInviteStatus;
(function (FolderShareInviteStatus) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    FolderShareInviteStatus[FolderShareInviteStatus["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from enum value: SENT = 1;
     */
    FolderShareInviteStatus[FolderShareInviteStatus["SENT"] = 1] = "SENT";
    /**
     * @generated from enum value: DECLINED = 2;
     */
    FolderShareInviteStatus[FolderShareInviteStatus["DECLINED"] = 2] = "DECLINED";
    /**
     * @generated from enum value: NOT_SENT = 3;
     */
    FolderShareInviteStatus[FolderShareInviteStatus["NOT_SENT"] = 3] = "NOT_SENT";
})(FolderShareInviteStatus || (FolderShareInviteStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(FolderShareInviteStatus)
proto3.util.setEnumType(FolderShareInviteStatus, "no.jotta.openapi.sharing.v2.FolderShareInviteStatus", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SENT" },
    { no: 2, name: "DECLINED" },
    { no: 3, name: "NOT_SENT" },
]);
/**
 * @generated from enum no.jotta.openapi.sharing.v2.Challenge
 */
export var Challenge;
(function (Challenge) {
    /**
     * @generated from enum value: UNKNOWN_CHALLENGE = 0;
     */
    Challenge[Challenge["UNKNOWN_CHALLENGE"] = 0] = "UNKNOWN_CHALLENGE";
    /**
     * @generated from enum value: PASSWORD = 1;
     */
    Challenge[Challenge["PASSWORD"] = 1] = "PASSWORD";
})(Challenge || (Challenge = {}));
// Retrieve enum metadata with: proto3.getEnumType(Challenge)
proto3.util.setEnumType(Challenge, "no.jotta.openapi.sharing.v2.Challenge", [
    { no: 0, name: "UNKNOWN_CHALLENGE" },
    { no: 1, name: "PASSWORD" },
]);
/**
 * @generated from message no.jotta.openapi.sharing.v2.RemovePassword
 */
export class RemovePassword extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.RemovePassword";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new RemovePassword().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemovePassword().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemovePassword().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemovePassword, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.PasswordUnchanged
 */
export class PasswordUnchanged extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.PasswordUnchanged";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new PasswordUnchanged().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PasswordUnchanged().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PasswordUnchanged().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PasswordUnchanged, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.SetPassword
 */
export class SetPassword extends Message {
    /**
     * @generated from field: string password = 1;
     */
    password = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.SetPassword";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new SetPassword().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPassword().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPassword().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPassword, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.EnableShareRequest
 */
export class EnableShareRequest extends Message {
    /**
     * path to the item you want to create a share link for.
     *
     * @generated from field: string path = 1;
     */
    path = "";
    /**
     * share_mode defaults to VIEW when not specified
     *
     * @generated from field: no.jotta.openapi.sharing.v2.ShareMode share_mode = 2;
     */
    shareMode = ShareMode.NOT_SET;
    /**
     * @generated from oneof no.jotta.openapi.sharing.v2.EnableShareRequest.password
     */
    password = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.EnableShareRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "share_mode", kind: "enum", T: proto3.getEnumType(ShareMode) },
        { no: 3, name: "password_unchanged", kind: "message", T: PasswordUnchanged, oneof: "password" },
        { no: 4, name: "set_password", kind: "message", T: SetPassword, oneof: "password" },
        { no: 5, name: "remove_password", kind: "message", T: RemovePassword, oneof: "password" },
    ]);
    static fromBinary(bytes, options) {
        return new EnableShareRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnableShareRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnableShareRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnableShareRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.EnableShareResponse
 */
export class EnableShareResponse extends Message {
    /**
     * @generated from field: string public_uri = 2;
     */
    publicUri = "";
    /**
     * @generated from field: string public_link = 3;
     */
    publicLink = "";
    /**
     * @generated from field: no.jotta.openapi.PublicShareRef ref = 4;
     */
    ref;
    /**
     * encoded ContentRef
     *
     * @generated from field: string encoded_ref = 5;
     */
    encodedRef = "";
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.PublicShareInfo public_share_info = 6;
     */
    publicShareInfo;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.EnableShareResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "public_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "public_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "ref", kind: "message", T: PublicShareRef },
        { no: 5, name: "encoded_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 6, name: "public_share_info", kind: "message", T: PublicShareInfo },
    ]);
    static fromBinary(bytes, options) {
        return new EnableShareResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnableShareResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnableShareResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnableShareResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.DisableShareRequest
 */
export class DisableShareRequest extends Message {
    /**
     * @generated from field: string path = 1;
     */
    path = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.DisableShareRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new DisableShareRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DisableShareRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DisableShareRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DisableShareRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.DisableShareResponse
 */
export class DisableShareResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.file.v2.PathItem item = 1;
     */
    item;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.DisableShareResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "item", kind: "message", T: PathItem },
    ]);
    static fromBinary(bytes, options) {
        return new DisableShareResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DisableShareResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DisableShareResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DisableShareResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.User
 */
export class User extends Message {
    /**
     * @generated from field: string username = 1;
     */
    username = "";
    /**
     * @generated from field: string email = 2;
     */
    email = "";
    /**
     * @generated from field: string name = 3;
     */
    name = "";
    /**
     * @generated from field: no.jotta.openapi.Avatar avatar = 4;
     */
    avatar;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.User";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "avatar", kind: "message", T: Avatar },
    ]);
    static fromBinary(bytes, options) {
        return new User().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new User().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new User().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(User, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.FolderShareInvite
 */
export class FolderShareInvite extends Message {
    /**
     * @generated from field: string email = 1;
     */
    email = "";
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.FolderShareInviteStatus status = 2;
     */
    status = FolderShareInviteStatus.UNKNOWN;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.FolderShareInvite";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(FolderShareInviteStatus) },
    ]);
    static fromBinary(bytes, options) {
        return new FolderShareInvite().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FolderShareInvite().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FolderShareInvite().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FolderShareInvite, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.GetShareInfoResponse
 */
export class GetShareInfoResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.ShareInfo share_info = 1;
     */
    shareInfo;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.GetShareInfoResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "share_info", kind: "message", T: ShareInfo },
    ]);
    static fromBinary(bytes, options) {
        return new GetShareInfoResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetShareInfoResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetShareInfoResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetShareInfoResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.PublicShareInfo
 */
export class PublicShareInfo extends Message {
    /**
     * @generated from field: string public_uri = 1;
     */
    publicUri = "";
    /**
     * @generated from field: string share_id = 2;
     */
    shareId = "";
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.ShareMode share_mode = 3;
     */
    shareMode = ShareMode.NOT_SET;
    /**
     * is a password set on this share? we dont store the password in cleartext, so we can't display it again.
     *
     * @generated from field: bool has_password = 4;
     */
    hasPassword = false;
    /**
     * a encoded content ref that represents this share.
     *
     * @generated from field: string encoded_content_ref = 5;
     */
    encodedContentRef = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.PublicShareInfo";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "public_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "share_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "share_mode", kind: "enum", T: proto3.getEnumType(ShareMode) },
        { no: 4, name: "has_password", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 5, name: "encoded_content_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PublicShareInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PublicShareInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PublicShareInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PublicShareInfo, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.ShareInfo
 */
export class ShareInfo extends Message {
    /**
     * @generated from field: no.jotta.openapi.file.v2.PathItem path_item = 1;
     */
    pathItem;
    /**
     * Deprecated. Refer to public_share_info instead.
     *
     * @generated from field: string public_uri = 2;
     */
    publicUri = "";
    /**
     * Deprecated. Refer to public_share_info instead.
     *
     * @generated from field: string public_link = 7;
     */
    publicLink = "";
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.User share_owner = 3;
     */
    shareOwner;
    /**
     * @generated from field: repeated no.jotta.openapi.sharing.v2.User members = 4;
     */
    members = [];
    /**
     * @generated from field: repeated no.jotta.openapi.sharing.v2.FolderShareInvite invites = 5;
     */
    invites = [];
    /**
     * Whether this path_item can invite users for sync sharing. This is only possible for folders in /Sync,
     * and requires that no parent folder is already part of a share.
     *
     * @generated from field: bool can_share_collaboratively = 6;
     */
    canShareCollaboratively = false;
    /**
     * @generated from field: string encoded_content_ref = 8;
     */
    encodedContentRef = "";
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.PublicShareInfo public_share_info = 9;
     */
    publicShareInfo;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.ShareInfo";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path_item", kind: "message", T: PathItem },
        { no: 2, name: "public_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 7, name: "public_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "share_owner", kind: "message", T: User },
        { no: 4, name: "members", kind: "message", T: User, repeated: true },
        { no: 5, name: "invites", kind: "message", T: FolderShareInvite, repeated: true },
        { no: 6, name: "can_share_collaboratively", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 8, name: "encoded_content_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 9, name: "public_share_info", kind: "message", T: PublicShareInfo },
    ]);
    static fromBinary(bytes, options) {
        return new ShareInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShareInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShareInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ShareInfo, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.GetShareInfoRequest
 */
export class GetShareInfoRequest extends Message {
    /**
     * @generated from field: string path = 1;
     */
    path = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.GetShareInfoRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetShareInfoRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetShareInfoRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetShareInfoRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetShareInfoRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.DeclineShareRequest
 */
export class DeclineShareRequest extends Message {
    /**
     * @generated from field: string invite_key = 1;
     */
    inviteKey = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.DeclineShareRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "invite_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new DeclineShareRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeclineShareRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeclineShareRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeclineShareRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.DeclineShareResponse
 */
export class DeclineShareResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.DeclineShareResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new DeclineShareResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeclineShareResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeclineShareResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeclineShareResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.JoinShareRequest
 */
export class JoinShareRequest extends Message {
    /**
     * @generated from field: string invite_key = 1;
     */
    inviteKey = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.JoinShareRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "invite_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new JoinShareRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new JoinShareRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new JoinShareRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(JoinShareRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.JoinShareResponse
 */
export class JoinShareResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.ShareInfo share_info = 1;
     */
    shareInfo;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.JoinShareResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "share_info", kind: "message", T: ShareInfo },
    ]);
    static fromBinary(bytes, options) {
        return new JoinShareResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new JoinShareResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new JoinShareResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(JoinShareResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.InviteMemberRequest
 */
export class InviteMemberRequest extends Message {
    /**
     * @generated from field: string path = 1;
     */
    path = "";
    /**
     * @generated from field: string email = 2;
     */
    email = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.InviteMemberRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new InviteMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InviteMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InviteMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InviteMemberRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.InviteMemberResponse
 */
export class InviteMemberResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.ShareInfo share_info = 1;
     */
    shareInfo;
    /**
     * @generated from field: string invite_key = 2;
     */
    inviteKey = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.InviteMemberResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "share_info", kind: "message", T: ShareInfo },
        { no: 2, name: "invite_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new InviteMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InviteMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InviteMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InviteMemberResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.RemoveMemberRequest
 */
export class RemoveMemberRequest extends Message {
    /**
     * @generated from field: string folder_share_id = 1;
     */
    folderShareId = "";
    /**
     * @generated from field: string member_username_or_email = 2;
     */
    memberUsernameOrEmail = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.RemoveMemberRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "folder_share_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "member_username_or_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new RemoveMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveMemberRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.RemoveMemberResponse
 */
export class RemoveMemberResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.ShareInfo share_info = 1;
     */
    shareInfo;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.RemoveMemberResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "share_info", kind: "message", T: ShareInfo },
    ]);
    static fromBinary(bytes, options) {
        return new RemoveMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveMemberResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.DisableFolderShareRequest
 */
export class DisableFolderShareRequest extends Message {
    /**
     * @generated from field: string folder_share_id = 1;
     */
    folderShareId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.DisableFolderShareRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "folder_share_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new DisableFolderShareRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DisableFolderShareRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DisableFolderShareRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DisableFolderShareRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.DisableFolderShareResponse
 */
export class DisableFolderShareResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.DisableFolderShareResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new DisableFolderShareResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DisableFolderShareResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DisableFolderShareResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DisableFolderShareResponse, a, b);
    }
}
/**
 * For addresses that come from not yet accepted share invites,
 * we may only have email OR username.
 * full_name is only known for registered customers.
 *
 * @generated from message no.jotta.openapi.sharing.v2.Address
 */
export class Address extends Message {
    /**
     * @generated from field: string username = 1;
     */
    username = "";
    /**
     * @generated from field: string email = 2;
     */
    email = "";
    /**
     * @generated from field: string full_name = 3;
     */
    fullName = "";
    /**
     * @generated from field: no.jotta.openapi.Avatar avatar = 4;
     */
    avatar;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.Address";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "avatar", kind: "message", T: Avatar },
    ]);
    static fromBinary(bytes, options) {
        return new Address().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Address().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Address().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Address, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.AddressBook
 */
export class AddressBook extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.sharing.v2.Address addresses = 1;
     */
    addresses = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.AddressBook";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "addresses", kind: "message", T: Address, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new AddressBook().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddressBook().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddressBook().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddressBook, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.GetAddressBookRequest
 */
export class GetAddressBookRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.GetAddressBookRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetAddressBookRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAddressBookRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAddressBookRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAddressBookRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.GetAddressBookResponse
 */
export class GetAddressBookResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.AddressBook address_book = 1;
     */
    addressBook;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.GetAddressBookResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address_book", kind: "message", T: AddressBook },
    ]);
    static fromBinary(bytes, options) {
        return new GetAddressBookResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAddressBookResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAddressBookResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAddressBookResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.ListPendingInvitesRequest
 */
export class ListPendingInvitesRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.ListPendingInvitesRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ListPendingInvitesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPendingInvitesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPendingInvitesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPendingInvitesRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.PendingInvite
 */
export class PendingInvite extends Message {
    /**
     * invite key can be used to join the share.
     *
     * @generated from field: string invite_key = 1;
     */
    inviteKey = "";
    /**
     * Deprecated: removed because ShareInfo.pathItem can not be produced for actor until after actor has joined the share.
     * ShareInfo share_info = 2;
     * owner has information about the owner that sent the invite.
     *
     * @generated from field: no.jotta.openapi.sharing.v2.User owner = 3;
     */
    owner;
    /**
     * @generated from field: string folder_share_id = 4;
     */
    folderShareId = "";
    /**
     * name a display friendly name, typically the name of the shared folder.
     *
     * @generated from field: string name = 5;
     */
    name = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.PendingInvite";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "invite_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "owner", kind: "message", T: User },
        { no: 4, name: "folder_share_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PendingInvite().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PendingInvite().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PendingInvite().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PendingInvite, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.ListPendingInvitesResponse
 */
export class ListPendingInvitesResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.sharing.v2.PendingInvite invites = 1;
     */
    invites = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.ListPendingInvitesResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "invites", kind: "message", T: PendingInvite, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ListPendingInvitesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPendingInvitesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPendingInvitesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPendingInvitesResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.LeaveShareRequest
 */
export class LeaveShareRequest extends Message {
    /**
     * @generated from field: string folder_share_id = 1;
     */
    folderShareId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.LeaveShareRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "folder_share_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new LeaveShareRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LeaveShareRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LeaveShareRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LeaveShareRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.LeaveShareResponse
 */
export class LeaveShareResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.LeaveShareResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new LeaveShareResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LeaveShareResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LeaveShareResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LeaveShareResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.FolderShareInfo
 */
export class FolderShareInfo extends Message {
    /**
     * @generated from field: no.jotta.openapi.file.v2.PathItem path_item = 1;
     */
    pathItem;
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.User share_owner = 2;
     */
    shareOwner;
    /**
     * @generated from field: repeated no.jotta.openapi.sharing.v2.User members = 3;
     */
    members = [];
    /**
     * @generated from field: repeated no.jotta.openapi.sharing.v2.FolderShareInvite invites = 4;
     */
    invites = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.FolderShareInfo";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path_item", kind: "message", T: PathItem },
        { no: 2, name: "share_owner", kind: "message", T: User },
        { no: 3, name: "members", kind: "message", T: User, repeated: true },
        { no: 4, name: "invites", kind: "message", T: FolderShareInvite, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new FolderShareInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FolderShareInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FolderShareInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FolderShareInfo, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.ListFolderSharesRequest
 */
export class ListFolderSharesRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.ListFolderSharesRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ListFolderSharesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFolderSharesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFolderSharesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFolderSharesRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.ListFolderSharesResponse
 */
export class ListFolderSharesResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.sharing.v2.FolderShareInfo shares = 1;
     */
    shares = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.ListFolderSharesResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "shares", kind: "message", T: FolderShareInfo, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ListFolderSharesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFolderSharesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFolderSharesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFolderSharesResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.ShareToken
 */
export class ShareToken extends Message {
    /**
     * access_token is a valid and signed openid token, containing among other things a @ShareAccessToken
     * Use this token as bearer token to the FileService API in a header: `Authorization: Bearer {access_token}`.
     *
     * @generated from field: string access_token = 1;
     */
    accessToken = "";
    /**
     * @generated from field: int64 expires_in_millis = 2;
     */
    expiresInMillis = protoInt64.zero;
    /**
     * @generated from field: int64 expires_at_millis = 3;
     */
    expiresAtMillis = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.ShareToken";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "expires_in_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 3, name: "expires_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new ShareToken().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ShareToken().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ShareToken().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ShareToken, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.LookupShareGranted
 */
export class LookupShareGranted extends Message {
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.ShareToken token = 1;
     */
    token;
    /**
     * @generated from field: string share_owner_name = 2;
     */
    shareOwnerName = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.LookupShareGranted";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "token", kind: "message", T: ShareToken },
        { no: 2, name: "share_owner_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new LookupShareGranted().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LookupShareGranted().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LookupShareGranted().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LookupShareGranted, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.Challenges
 */
export class Challenges extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.sharing.v2.Challenge requested_challenges = 1;
     */
    requestedChallenges = [];
    /**
     * @generated from field: repeated no.jotta.openapi.sharing.v2.Challenge accepted_challenges = 2;
     */
    acceptedChallenges = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.Challenges";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "requested_challenges", kind: "enum", T: proto3.getEnumType(Challenge), repeated: true },
        { no: 2, name: "accepted_challenges", kind: "enum", T: proto3.getEnumType(Challenge), repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new Challenges().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Challenges().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Challenges().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Challenges, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.Credentials
 */
export class Credentials extends Message {
    /**
     * @generated from field: string password = 1;
     */
    password = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.Credentials";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Credentials().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Credentials().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Credentials().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Credentials, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.LookupShareRequest
 */
export class LookupShareRequest extends Message {
    /**
     * @generated from field: string share_id = 1;
     */
    shareId = "";
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.Credentials credentials = 2;
     */
    credentials;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.LookupShareRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "share_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "credentials", kind: "message", T: Credentials },
    ]);
    static fromBinary(bytes, options) {
        return new LookupShareRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LookupShareRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LookupShareRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LookupShareRequest, a, b);
    }
}
/**
 * Any challenges given in the response must be resolved.
 *
 * When access is granted, a LookupShareGranted is set, containing credentials for accessing the share.
 *
 * @generated from message no.jotta.openapi.sharing.v2.LookupShareResponse
 */
export class LookupShareResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.sharing.v2.LookupShareResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.LookupShareResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "challenge", kind: "message", T: Challenges, oneof: "result" },
        { no: 2, name: "granted", kind: "message", T: LookupShareGranted, oneof: "result" },
        { no: 3, name: "errors", kind: "message", T: LookupShareResponse_LookupShareError, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new LookupShareResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LookupShareResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LookupShareResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LookupShareResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError
 */
export class LookupShareResponse_LookupShareError extends Message {
    /**
     * @generated from field: no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.ShareError error_kind = 1;
     */
    errorKind = LookupShareResponse_LookupShareError_ShareError.UNKNOWN_ERROR;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "error_kind", kind: "enum", T: proto3.getEnumType(LookupShareResponse_LookupShareError_ShareError) },
    ]);
    static fromBinary(bytes, options) {
        return new LookupShareResponse_LookupShareError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LookupShareResponse_LookupShareError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LookupShareResponse_LookupShareError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LookupShareResponse_LookupShareError, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.ShareError
 */
export var LookupShareResponse_LookupShareError_ShareError;
(function (LookupShareResponse_LookupShareError_ShareError) {
    /**
     * @generated from enum value: UNKNOWN_ERROR = 0;
     */
    LookupShareResponse_LookupShareError_ShareError[LookupShareResponse_LookupShareError_ShareError["UNKNOWN_ERROR"] = 0] = "UNKNOWN_ERROR";
    /**
     * No such share found
     *
     * @generated from enum value: NOT_FOUND = 1;
     */
    LookupShareResponse_LookupShareError_ShareError[LookupShareResponse_LookupShareError_ShareError["NOT_FOUND"] = 1] = "NOT_FOUND";
    /**
     * Share has exceeded its allowed quota
     *
     * @generated from enum value: DOWNLOADS_EXCEEDED = 2;
     */
    LookupShareResponse_LookupShareError_ShareError[LookupShareResponse_LookupShareError_ShareError["DOWNLOADS_EXCEEDED"] = 2] = "DOWNLOADS_EXCEEDED";
    /**
     * Customer owning the share has disabled it
     *
     * @generated from enum value: DISABLED = 3;
     */
    LookupShareResponse_LookupShareError_ShareError[LookupShareResponse_LookupShareError_ShareError["DISABLED"] = 3] = "DISABLED";
    /**
     * We have disabled the share. Please contact support
     *
     * @generated from enum value: DISABLED_BY_ADMIN = 4;
     */
    LookupShareResponse_LookupShareError_ShareError[LookupShareResponse_LookupShareError_ShareError["DISABLED_BY_ADMIN"] = 4] = "DISABLED_BY_ADMIN";
    /**
     * Time limited shares can expire.
     *
     * @generated from enum value: SHARE_EXPIRED = 5;
     */
    LookupShareResponse_LookupShareError_ShareError[LookupShareResponse_LookupShareError_ShareError["SHARE_EXPIRED"] = 5] = "SHARE_EXPIRED";
})(LookupShareResponse_LookupShareError_ShareError || (LookupShareResponse_LookupShareError_ShareError = {}));
// Retrieve enum metadata with: proto3.getEnumType(LookupShareResponse_LookupShareError_ShareError)
proto3.util.setEnumType(LookupShareResponse_LookupShareError_ShareError, "no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.ShareError", [
    { no: 0, name: "UNKNOWN_ERROR" },
    { no: 1, name: "NOT_FOUND" },
    { no: 2, name: "DOWNLOADS_EXCEEDED" },
    { no: 3, name: "DISABLED" },
    { no: 4, name: "DISABLED_BY_ADMIN" },
    { no: 5, name: "SHARE_EXPIRED" },
]);
